import React from 'react';
import {useSelector} from 'react-redux';
import {Redirect, Route, Switch} from 'react-router-dom';
import AccountConfirmation from './account/component/AccountConfirmation';
import AccountSettings from './account/component/AccountSettings';
import Login from './account/component/Login';
import PasswordReset from './account/component/passwordReset/PasswordReset';
import PasswordResetRequest from './account/component/passwordReset/PasswordResetRequest';
import Registration from './account/component/Registration';
import Imprint from './information/component/Imprint';
import PrivacyPolicy from './information/component/PrivacyPolicy';
import TermsAndConditions from './information/component/TermsAndConditions';
import Messages from './message/component/Messages';
import TrainingOverview from './training/component/TrainingOverview';
import TrainingDetails from './training/component/TrainingDetails';
import ClubOverview from './club/component/ClubOverview';
import ClubDetail from './club/component/ClubDetail';
import TrainingEdit from './training/component/TrainingEdit';
import AccountRoles from './account/enums/AccountRoles';

function AppRoutes() {
    const isLoggedIn = useSelector(state => state.account.isLoggedIn);
    const role = useSelector(state => state.account.role);
    const club = useSelector(state => state.account.club);

    let defaultPath = '/trainings';

    if (!isLoggedIn) {
        defaultPath = '/login';
    }

    if (role === AccountRoles.CLUB_MANAGER) {
        defaultPath = `/club/${club?.id}`;
    }

    return (
        <>
            {
                isLoggedIn ?
                    <div id="content" className="container">
                        <Messages/>
                        <Switch>
                            <Route path="/terms-and-conditions" exact render={() => <TermsAndConditions/>}/>
                            <Route path="/imprint" exact render={() => <Imprint/>}/>
                            <Route path="/privacy-policy" exact render={() => <PrivacyPolicy/>}/>
                            <Route path="/confirm" exact render={() => <AccountConfirmation/>}/>
                            <Route path="/request-password-reset" exact render={() => <PasswordResetRequest/>}/>
                            <Route path="/password-reset" exact render={() => <PasswordReset/>}/>
                            <Route path="/trainings" exact render={() => <TrainingOverview/>}/>
                            <Route path="/training/:id" exact render={() => <TrainingDetails/>}/>
                            <Route path="/training-edit/:id" exact render={() => <TrainingEdit/>}/>
                            <Route path="/training/shared/:token" exact render={() => <TrainingDetails/>}/>
                            <Route path="/account-settings" exact render={() => <AccountSettings/>}/>
                            <Route path="/clubs" exact render={() => <ClubOverview/>}/>
                            <Route path="/club/:id" exact render={() => <ClubDetail/>}/>
                            <Redirect to={{pathname: defaultPath}}/>
                        </Switch>
                    </div>
                    :
                    <div id="content" className="container">
                        <Messages/>
                        <Switch>
                            <Route path="/login" exact render={() => <Login/>}/>
                            <Route path="/training/shared/:token" exact render={() => <TrainingDetails/>}/>
                            <Route path="/terms-and-conditions" exact render={() => <TermsAndConditions/>}/>
                            <Route path="/password-reset" exact render={() => <PasswordReset/>}/>
                            <Route path="/request-password-reset" exact render={() => <PasswordResetRequest/>}/>
                            <Route path="/imprint" exact render={() => <Imprint/>}/>
                            <Route path="/privacy-policy" exact render={() => <PrivacyPolicy/>}/>
                            <Route path="/register" exact render={() => <Registration/>}/>
                            <Route path="/confirm" exact render={() => <AccountConfirmation/>}/>
                            <Redirect to={{pathname: defaultPath}}/>
                        </Switch>
                    </div>
            }
        </>
    );
}

export default AppRoutes;
